import styled from '@emotion/styled';
import { themeColors } from '../../../constants/themes';

export const InfoLabel = styled.span`
  font-size: ${({ theme }) => theme.fontSize.medium};
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.07;
  letter-spacing: 0px;
  text-align: left;
  color: ${themeColors.darkBlue};
`;

export const InfoContainer = styled.div`
  width: 48%;
  margin-left: 26%;
  margin-top: 13px;
`;
